var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeatPump(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 66,
    viewBox: "0 0 47 66",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7097 62.2983V63.7312C18.7097 63.8042 18.7398 64.2788 18.3298 64.653C17.9198 65.0272 17.4098 64.9999 17.3298 64.9907H16.5498C15.7898 64.9907 15.1699 64.4249 15.1699 63.7312V61.778",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4595 62.2982C28.4595 62.6633 28.4595 63.3661 28.4595 63.7312C28.4595 63.8042 28.4296 64.2514 28.8096 64.6256C29.2196 65.018 29.7697 64.9998 29.8397 64.9998H30.6197C31.3797 64.9998 31.9996 64.4339 31.9996 63.7403V61.8145",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1899 55.8091C36.8499 57.817 36.7301 58.3281 36.3901 60.336C36.3201 60.7741 35.9801 61.1118 35.5601 61.194C27.5501 62.6634 19.3501 62.6634 11.3501 61.194C10.9301 61.1118 10.59 60.7741 10.52 60.336L9.75 55.7726",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.44995 3.42974C15.86 0.299195 30.45 0.0892751 44.75 3.42974C45.59 3.63053 46.1702 4.32418 46.1702 5.11822V52.6878C46.1702 53.4819 45.59 54.1755 44.75 54.3763C30.46 57.7259 15.86 57.516 2.44995 54.3763C1.59995 54.1755 1 53.4819 1 52.6787V5.11822C1 4.31505 1.59995 3.6214 2.44995 3.42061V3.42974Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1702 4.8442V6.66046C30.9102 2.82715 15.24 3.09183 1 6.66046V4.8442C1 4.21444 1.46013 3.6577 2.13013 3.50254C15.7201 0.271605 30.54 0.061685 45.04 3.50254C45.71 3.6577 46.1702 4.21444 46.1702 4.8442Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1702 52.9615V51.1452C30.9102 54.9785 15.24 54.7138 1 51.1452V52.9615C1 53.5912 1.46013 54.148 2.13013 54.3031C15.7201 57.5341 30.54 57.744 45.04 54.3031C45.71 54.148 46.1702 53.5912 46.1702 52.9615Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5801 60.1717C24.0606 60.1717 24.45 59.8162 24.45 59.3777C24.45 58.9391 24.0606 58.5836 23.5801 58.5836C23.0996 58.5836 22.71 58.9391 22.71 59.3777C22.71 59.8162 23.0996 60.1717 23.5801 60.1717Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2002 59.3777H28.1704",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0898 59.3777H21.0598",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4889 17.3716C30.9996 13.7825 28.2258 10.4952 24.2934 10.0291C20.361 9.56291 16.7592 12.0945 16.2485 15.6835C15.7377 19.2726 18.5116 22.5599 22.4439 23.0261C26.3763 23.4922 29.9781 20.9606 30.4889 17.3716Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5798 20.4969C25.9657 20.4969 27.8999 18.7316 27.8999 16.5541C27.8999 14.3765 25.9657 12.6112 23.5798 12.6112C21.194 12.6112 19.2598 14.3765 19.2598 16.5541C19.2598 18.7316 21.194 20.4969 23.5798 20.4969Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8901 16.983L26.28 13.4783",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatPump);
export default __webpack_public_path__ + "static/media/heatPump.b261abe8dce67e66fc98e7bc0cf604e4.svg";
export { ForwardRef as ReactComponent };